/* eslint-disable prettier/prettier */
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
export const VERSION = {
  "gitBuildGlobalVersion": "2.10.0",
  "gitBuildTime": "2026-10-07T18:31:18.114Z",
  "gitBuildVersion": "2.10.0",
  "gitCommitId": "7aaf47a",
  "gitCommitIdFull": "7aaf47a2326d18b416d1f8e3d8839df479fb1bb6",
  "gitCommitTime": "2026-10-07T18:29:42.000Z",
  "version": "2.10.0-2026-10-07T18:29:42.000Z-(7aaf47a)"
};
